import icon from 'vue-svgicon';

icon.register({
    'regular/view-off': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.783 21l18.75-18M8.964 19.051A9.985 9.985 0 0 0 12 19.5c4.1.069 8.258-2.813 10.824-5.637a1.663 1.663 0 0 0 0-2.226A20.568 20.568 0 0 0 19.75 8.88M14.413 6.282A9.549 9.549 0 0 0 12 6c-4.031-.067-8.2 2.752-10.821 5.635a1.663 1.663 0 0 0 0 2.226 20.8 20.8 0 0 0 2.6 2.4M8.25 12.75A3.749 3.749 0 0 1 12 9"/><path pid="1" d="M15.75 12.749h0A3.75 3.75 0 0 1 12 16.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
